import { NavLink, NavLinkProps, useLocation } from "react-router-dom";
import T from "../../../../common/i18n/Text";

interface NavLinkWithLocationProps extends NavLinkProps {
  textPath: string;
}

function NavLinkWithLocation({ textPath, ...rest }: NavLinkWithLocationProps) {
  const location = useLocation();
  const activeClass = "active text-[#DC3545] underline";
  const inactiveClass = "";
  const isActive = location.pathname === rest.to;
  const className = `nav-link ${isActive ? activeClass : inactiveClass}`;

  return (
    <NavLink className={className} {...rest}>
      <T path={textPath} />
    </NavLink>
  );
}
export default NavLinkWithLocation;
